<template>
  <div class="top">
    <div class="block">
      <el-form :inline="true">
        <el-form-item>
          <el-autocomplete style="width: 40%;margin-right:5px" placeholder="请输入交易对搜索" v-model="pair" :fetch-suggestions="querySearchAsync"  @change="findOne"/>
          <el-button type="primary" @click="findOne">搜索</el-button>
          <el-button type="primary" @click="addStrategy">新增</el-button>
          <el-button type="primary" @click="exportExcel">导出</el-button>
        </el-form-item>
      </el-form>

      <el-form :model="brushData" label-width="200px" ref="formBrush" :rules="rules">
        <el-form-item label="用户ID" prop="userId">
          <el-input v-model="brushData.userId" disabled style="width: 500px"></el-input>
        </el-form-item>
        <el-form-item label="类型" prop="machineType">
          <el-select v-model="brushData.machineType" disabled>
            <el-option v-for="item in machineBrushTypes" :label="item.desc" :key="item.code" :value="item.code"/>
          </el-select>
        </el-form-item>
        <el-form-item label="数量(arg)" prop="arg">
          <el-input v-model="brushData.arg" style="width: 500px"></el-input>
        </el-form-item>
        <el-form-item label="买方向触发" prop="buyDirectionTrigger">
          <el-input-number v-model="brushData.buyDirectionTrigger"></el-input-number>
        </el-form-item>
        <el-form-item label="卖方向触发" prop="sellDirectionTrigger">
          <el-input-number v-model="brushData.sellDirectionTrigger"></el-input-number>
        </el-form-item>
        <el-form-item label="买方向概率" prop="buyDirectionProbability">
          <el-input-number v-model="brushData.buyDirectionProbability"></el-input-number>
        </el-form-item>
        <el-form-item label="卖方向概率" prop="sellDirectionProbability">
          <el-input-number v-model="brushData.sellDirectionProbability"></el-input-number>
        </el-form-item>
        <el-form-item label="买最小比值" prop="buyMinPriceRate">
          <el-input-number v-model="brushData.buyMinPriceRate"></el-input-number>
        </el-form-item>
        <el-form-item label="买最大比值" prop="buyMaxPriceRate">
          <el-input-number v-model="brushData.buyMaxPriceRate"></el-input-number>
        </el-form-item>
        <el-form-item label="卖最小比值" prop="sellMinPriceRate">
          <el-input-number v-model="brushData.sellMinPriceRate"></el-input-number>
        </el-form-item>
        <el-form-item label="卖最大比值" prop="sellMaxPriceRate">
          <el-input-number v-model="brushData.sellMaxPriceRate"></el-input-number>
        </el-form-item>
        <el-form-item label="交易量最小值" prop="amountMinValue">
          <el-input-number v-model="brushData.amountMinValue"></el-input-number>
        </el-form-item>
        <el-form-item label="交易量最大值" prop="amountMaxValue">
          <el-input-number v-model="brushData.amountMaxValue"></el-input-number>
        </el-form-item>
        <el-form-item label="阈值" prop="threshold">
          <el-input-number v-model="brushData.threshold"></el-input-number>
        </el-form-item>
        <el-form-item label="阈值交易量最小倍数" prop="thresholdAmountMinMultiple">
          <el-input-number v-model="brushData.thresholdAmountMinMultiple"></el-input-number>
        </el-form-item>
        <el-form-item label="阈值交易量最大倍数" prop="thresholdAmountMaxMultiple">
          <el-input-number v-model="brushData.thresholdAmountMaxMultiple"></el-input-number>
        </el-form-item>
        <el-form-item label="价差比" prop="priceDifferenceRate">
          <el-input-number v-model="brushData.priceDifferenceRate"></el-input-number>
        </el-form-item>
        <el-form-item  label="是否启动" prop="enable">
          <el-radio-group v-model="brushData.enable">
            <el-radio class="radio" :label="1">是</el-radio>
            <el-radio class="radio" :label="0">否</el-radio>
          </el-radio-group>
        </el-form-item>
        <el-form-item>
          <el-button type="primary" @click="submitBrush(brushData)">确认修改</el-button>
        </el-form-item>
      </el-form>
      <el-dialog title="新增" :visible.sync="dialogVisible" width="40%" @close="clearData" :close-on-click-modal="false">
        <div>
          <el-form :model="formData" label-width="150px" ref="formBrush" :rules="rules">
            <el-form-item label="交易对" prop="pair">
              <el-input v-model="formData.pair"/>
            </el-form-item>
            <el-form-item label="用户ID" prop="userId">
              <el-input v-model="formData.userId"/>
            </el-form-item>
            <el-form-item label="类型" prop="machineType">
              <el-select v-model="formData.machineType">
                <el-option v-for="item in machineBrushTypes" :label="item.desc" :key="item.code" :value="item.code"/>
              </el-select>
            </el-form-item>
            <el-form-item label="数量(arg)" prop="arg">
              <el-input v-model="formData.arg"/>
            </el-form-item>
            <el-form-item label="买方向触发" prop="buyDirectionTrigger">
              <el-input-number v-model="formData.buyDirectionTrigger"></el-input-number>
            </el-form-item>
            <el-form-item label="卖方向触发" prop="sellDirectionTrigger">
              <el-input-number v-model="formData.sellDirectionTrigger"></el-input-number>
            </el-form-item>
            <el-form-item label="买方向概率" prop="buyDirectionProbability">
              <el-input-number v-model="formData.buyDirectionProbability"></el-input-number>
            </el-form-item>
            <el-form-item label="卖方向概率" prop="sellDirectionProbability">
              <el-input-number v-model="formData.sellDirectionProbability"></el-input-number>
            </el-form-item>
            <el-form-item label="买最小比值" prop="buyMinPriceRate">
              <el-input-number v-model="formData.buyMinPriceRate"></el-input-number>
            </el-form-item>
            <el-form-item label="买最大比值" prop="buyMaxPriceRate">
              <el-input-number v-model="formData.buyMaxPriceRate"></el-input-number>
            </el-form-item>
            <el-form-item label="卖最小比值" prop="sellMinPriceRate">
              <el-input-number v-model="formData.sellMinPriceRate"></el-input-number>
            </el-form-item>
            <el-form-item label="卖最大比值" prop="sellMaxPriceRate">
              <el-input-number v-model="formData.sellMaxPriceRate"></el-input-number>
            </el-form-item>
            <el-form-item label="交易量最小值" prop="amountMinValue">
              <el-input-number v-model="formData.amountMinValue"></el-input-number>
            </el-form-item>
            <el-form-item label="交易量最大值" prop="amountMaxValue">
              <el-input-number v-model="formData.amountMaxValue"></el-input-number>
            </el-form-item>
            <el-form-item label="阈值" prop="threshold">
              <el-input-number v-model="formData.threshold"></el-input-number>
            </el-form-item>
            <el-form-item label="阈值交易量最小倍数" prop="thresholdAmountMinMultiple">
              <el-input-number v-model="formData.thresholdAmountMinMultiple"></el-input-number>
            </el-form-item>
            <el-form-item label="阈值交易量最大倍数" prop="thresholdAmountMaxMultiple">
              <el-input-number v-model="formData.thresholdAmountMaxMultiple"></el-input-number>
            </el-form-item>
            <el-form-item label="价差比" prop="priceDifferenceRate">
              <el-input-number v-model="formData.priceDifferenceRate"></el-input-number>
            </el-form-item>
            <el-form-item  label="是否启动">
              <el-radio-group v-model="formData.enable">
                <el-radio class="radio" label="1">是</el-radio>
                <el-radio class="radio" label="0">否</el-radio>
              </el-radio-group>
            </el-form-item>
            <el-form-item>
              <el-button type="primary" @click="submitBrush(formData)">确认</el-button>
            </el-form-item>
          </el-form>
        </div>
      </el-dialog>


    </div>
  </div>
</template>

<script>
import './cache';
import {mapState, mapActions} from 'vuex';
import api from "@/entries/Machine/api";
import utils from "@/entries/HedgeCenter/MarketSheet/utils";

export default {
  name: "QuotationBrush",
  data(){
    return {
      pair:'',
      brushConfig:{},
      brushData:{},
      dialogVisible:false,
      formData: {},
      rules: {
        thresholdStopProcessDepth: [{required: true, message: '数据不能为空', trigger: 'blur'}],
        dealAmtPercentage: [{required: true, message: '数据不能为空', trigger: 'blur'}],
        bidBaseAmt: [{required: true, message: '数据不能为空', trigger: 'blur'}],
        askBaseAmt: [{required: true, message: '数据不能为空', trigger: 'blur'}],
        bidPriceDensity: [{required: true, message: '数据不能为空', trigger: 'blur'}],
        askPriceDensity: [{required: true, message: '数据不能为空', trigger: 'blur'}],
        bidFirstPlaceDiscounted: [{required: true, message: '数据不能为空', trigger: 'blur'}],
        askFirstPlaceDiscounted: [{required: true, message: '数据不能为空', trigger: 'blur'}],
        interval: [{required: true, message: '数据不能为空', trigger: 'blur'}],
        userId: [{required: true, message: '用户Id不能为空', trigger: 'blur'}],
        machineType: [{required: true, message: '类型不能为空', trigger: 'blur'}],
        pair: [{required: true, message: '交易对不能为空', trigger: 'blur'}],
        askPositionAmount: [{required: true, message: '数量不能为空', trigger: 'blur'}],
        bidPositionAmount: [{required: true, message: '数量不能为空', trigger: 'blur'}],
        bidPositionReduce: [{required: true, message: '数量不能为空', trigger: 'blur'}],
        askPositionReduce: [{required: true, message: '数量不能为空', trigger: 'blur'}],
      },
    }
  },
  computed: {
    ...mapState('quotationCache', ['brushConfigurations', 'machineBrushTypes']),
  },
  methods:{
    ...mapActions('quotationCache', ['queryBrushConfigurations']),

    createStateFilter(queryString) {
      return (state) => {
        return (state.pair.toLowerCase().indexOf(queryString.toLowerCase()) === 0);
      };
    },

    querySearchAsync(queryString, cb) {
      let restaurants = this.brushConfigurations;
      let results = queryString ? restaurants.filter(this.createStateFilter(queryString)) : restaurants;
      let suggest = [];
      for(let index in results) {
        suggest.push({'value':results[index].pair});
      }
      cb(suggest);
    },

    deepCopy(source) {
      let sourceCopy = source instanceof Array ? [] : {};
      for (let item in source) {
        sourceCopy[item] = typeof source[item] === 'object' ? this.deepCopy(source[item]) : source[item];
      }
      return sourceCopy;
    },

    findOne(){
      this.brushData = {};
      for (let i in this.brushConfigurations) {
        if (this.pair === this.brushConfigurations[i].pair) {
          this.brushData = JSON.parse(JSON.stringify(this.brushConfigurations[i]));
          return;
        }
      }
    },

    submitBrush(data){
      this.$refs['formBrush'].validate( (valid) =>{
        if (valid) {
          api.saveBrushConfig(data).then(() =>{
            this.$message.success('设置成功');
            this.queryBrushConfigurations();
          });
        }
      })
    },

    clearData(){
      this.formData = {};
    },

    addStrategy(){
      this.formData = {
        userId:"2018061100000000731910010",
        machineType:'BY_QUANTITY',
        buyDirectionTrigger:0.01,
        sellDirectionTrigger:0.99,
        buyDirectionProbability:0.6,
        sellDirectionProbability:0.6,
        buyMinPriceRate:0.001,
        buyMaxPriceRate:0.005,
        sellMinPriceRate:0.001,
        sellMaxPriceRate:0.005,
        amountMinValue:0.01,
        amountMaxValue:15.1315,
        threshold:0.01,
        thresholdAmountMinMultiple:3,
        thresholdAmountMaxMultiple:8,
        priceDifferenceRate:0.15,
        enable:'1'
      };
      this.dialogVisible=true;
    },

    exportExcel(){
      const columns = [{title:'id', key:'id'},{title:'币对', key:'pair'},{title:'用户id', key:'userId'},
        {title:'类型', key:'machineType'},{title:'基础值', key:'arg'}, {title:'时间', key:'createdTime'},
        {title:'是否启用', key:'enable'},{title:'买方向触发', key:'buyDirectionTrigger'}, {title:'卖方向触发', key:'sellDirectionTrigger'},
        {title:'买方向概率', key:'buyDirectionProbability'},{title:'卖方向概率', key:'sellDirectionProbability'}, {title:'买最小比值', key:'buyMinPriceRate'},
        {title:'买最大比值', key:'buyMaxPriceRate'},{title:'卖最小比值', key:'sellMinPriceRate'}, {title:'卖最大比值', key:'sellMaxPriceRate'},
        {title:'交易量最小值', key:'amountMinValue'},{title:'交易量最大值', key:'amountMaxValue'}, {title:'阈值', key:'threshold'},
        {title:'达到阈值后交易量最小倍数', key:'thresholdAmountMinMultiple'},{title:'达到阈值后交易量最大倍数', key:'thresholdAmountMaxMultiple'}, {title:'价差比', key:'priceDifferenceRate'}]

      const obj = {"id":"id","pair":"pair","userId":"userId","machineType":"machineType","arg":"arg",
        "createdTime":"createdTime","enable":"enable","buyDirectionTrigger":"buyDirectionTrigger",
        "sellDirectionTrigger":"sellDirectionTrigger","buyDirectionProbability":"buyDirectionProbability","sellDirectionProbability":"sellDirectionProbability",
        "buyMinPriceRate":"buyMinPriceRate","buyMaxPriceRate":"buyMaxPriceRate","sellMinPriceRate":"sellMinPriceRate",
        "sellMaxPriceRate":"sellMaxPriceRate","amountMinValue":"amountMinValue","amountMaxValue":"amountMaxValue","threshold":"threshold",
        "thresholdAmountMinMultiple":"thresholdAmountMinMultiple","thresholdAmountMaxMultiple":"thresholdAmountMaxMultiple","priceDifferenceRate":"priceDifferenceRate"}
      const list = this.brushConfigurations.filter((item)=>{return item;})
      list.unshift(obj);
      api.export2Excel("刷量", columns, list);
    },

  },
}
</script>

<style scoped>
.block{
  background-color: white;
  margin: 10px 15px 10px 15px;
  padding: 40px 30px 10px 30px;
  height: auto;
}
</style>